import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3;
import styled from 'styled-components';
import ResponsiveImage from '@magalu/stereo-ui/atoms/ResponsiveImage';
export var BannerContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
export var Image = styled(ResponsiveImage)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  height: ", ";\n  width: 100%;\n  object-fit: cover;\n  object-position: ", ";\n  display: block;\n"])), function (_ref) {
  var height = _ref.height;
  return height && height.trim() !== '' ? height : 'auto';
}, function (_ref2) {
  var position = _ref2.position;
  return position;
});
export var ImageWrapper = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: ", ";\n  overflow: hidden;\n  border-radius: 8px;\n"])), function (_ref3) {
  var height = _ref3.height;
  return height || '228px';
});